import styled from 'styled-components';

const StyledButton = styled.button`
    border: none;
    background: none;
    cursor: pointer;
`;

const IconButton = (props) => {
    return <StyledButton {...props} />;
};

export default IconButton;
